import { db } from "../Firebase";
import { infoSite } from "../../state/atom";
import { useRecoilValue } from "recoil";
import "./style.css";

function PutData(params: any) {
  const Info = useRecoilValue(infoSite);

  async function PutFirestore(params: any) {
    try {
      db.collection("Ziano")
        .doc("InfoSito")
        .update({
          Nome: Info.Nome,
          Regione: { Nome: Info.Regione.Nome, Url: Info.Regione.Url },
          Colore: {
            Rgba: {
              a: Info.Colore.Rgba.a,
              b: Info.Colore.Rgba.b,
              r: Info.Colore.Rgba.r,
              g: Info.Colore.Rgba.g,
            },
          },
        });
    } catch (err) {
      console.log(err);
    }
  }
  return (
    <button className="SaveInfo" onClick={PutFirestore}>
      Save info
    </button>
  );
}

export default PutData;
